export default __webpack_public_path__ + "static/media/review15.d96a5283.jpg";